import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import { Service } from '../shared/services/service';
import { Funcoes } from '../funcoes';

@Injectable()
export class ConfiguracoesService extends Service {
  protected url: string = this.dominio + '/adm/configuracoes/';

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  getConfiguracoes() {
    let headers = this.getHeaderLogado();
    return this.http.get(this.url, { headers })
      .map(res => {
        let json = res.json();
        if (!json.Success) {
          this.trataErro(json);
        }
        return json;
      });
  }

  salvarConfiguracoes(values, id) {
    let headers = this.getHeaderLogado();
    let targetUrl = id ? this.url + id : this.url + '1';
    return this.http.put(targetUrl, JSON.stringify(values), { headers })
      .map(res => {
        let json = res.json();
        if (!json.Success) {
          this.trataErro(json);
        }
        return json;
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/configuracoes/configuracoes.service.ts